//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import emptyCell from "../components/emptyCell";
import util from '@/lib/util';

export default {
    name: "active-list",
    components: {
        emptyCell
    },
    props: {
        IsEffective: {
            type: Boolean
        }
    },
    data() {
        return {
            active: [],
            pageIndex: 1,
            pageSize: 10,
            refreshing: false,
            loading: false,
            finished: false,
            list: [],
            downloadUrl: util.ApiUrl + 'file/download/',
        };
    },
    methods: {
        goToActiveDetail(id) {
            this.$router.push({path: '/my-activeDetail/' + id})
        },
        onRefresh() {
            this.pageIndex = 1;
            this.getOrders();
        },
        onLoad() {
            this.pageIndex++;
            this.getOrders();
        },
        getOrders() {
            if (!localStorage.getItem('MemberId') || parseInt(localStorage.getItem('MemberId')) <= 0) {
                return
            }
            this.refreshing = this.pageIndex === 1;
            this.loading = this.pageIndex > 1;
            var params = {
                orderStatus: this.status,
                memberId: localStorage.getItem('MemberId'),
                filter: '',
                sorting: '',
                maxResultCount: this.pageSize,
                skipCount: (this.pageIndex - 1) * this.pageSize
            };
            if (this.status === 9) {
                params.orderStatus = '';
            }
            params.isEffective = this.IsEffective;

            abp.ajax.post('/api/services/app/Activity/SearchSignUpRecords', params)
                .then(res => {
                    if (this.pageIndex === 1) {
                        this.list = [];
                    }
                    this.list.push(...res.data.result.items);
                    if (res.data.result.items.length < this.pageSize) {
                        this.finished = true;
                    }
                })
                .catch(() => {
                })
                .then(() => {
                    this.refreshing = false;
                    this.loading = false;
                });
        }
    },
    created() {
        // this.loading = true;
        this.getOrders();
    }
}
